/* eslint-disable max-len */
import clsx from 'clsx';
import camelCase from 'lodash/camelCase';
import Link from 'next/link';
import React from 'react';
import Popup from 'reactjs-popup';
import { useLayoutContext } from '../../LayoutContext';
import Badge from './Badge';
import styles from './ReglamentBadge.module.scss';

const FzIcon: any = () => (
    <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.icon}
    >
        <path d="M13.391 12.359a1.643 1.643 0 00.385 1.71l.663.663c.32.32.74.48 1.16.48.42 0 .84-.16 1.16-.48l3.978-3.977c.64-.64.64-1.68 0-2.32l-.663-.663a1.643 1.643 0 00-1.71-.385L13.83 2.854a1.643 1.643 0 00-.385-1.711L12.782.48c-.64-.64-1.68-.64-2.32 0L6.484 4.457c-.64.64-.64 1.68 0 2.32l.663.663a1.636 1.636 0 001.711.385l.742.742-8.614 7.57A2.91 2.91 0 000 18.223c-.025.798.284 1.58.849 2.144a2.912 2.912 0 002.144.848 2.912 2.912 0 002.085-.984l7.57-8.614.742.742zm5.357-3.593a.234.234 0 01.332 0l.663.663a.235.235 0 010 .332l-3.978 3.977a.235.235 0 01-.331 0l-.663-.663a.235.235 0 010-.331l3.977-3.978zm-5.8-4.806l4.309 4.309-2.984 2.983-4.308-4.309 2.983-2.983zM8.473 6.446a.235.235 0 01-.331 0l-.663-.663a.235.235 0 010-.331l3.977-3.978a.233.233 0 01.332 0l.662.663a.235.235 0 010 .332L8.473 6.446zm-4.45 12.857a1.48 1.48 0 01-1.074.507 1.481 1.481 0 01-1.105-.437 1.48 1.48 0 01-.437-1.105 1.48 1.48 0 01.507-1.074l6.213-5.46 1.355 1.356-5.459 6.213zm6.39-7.271l-1.228-1.228 1.412-1.24 1.056 1.056-1.24 1.412zM23.297 22.595h-.704v-.703c0-1.163-.946-2.11-2.109-2.11h-4.687c-1.164 0-2.11.947-2.11 2.11v.703h-.703a.703.703 0 000 1.406h10.313a.703.703 0 100-1.406zm-2.11 0h-6.094v-.703c0-.388.316-.703.704-.703h4.687c.388 0 .703.315.703.703v.703zM17.437 16.267v1.406a.703.703 0 001.406 0v-1.406a.703.703 0 00-1.406 0zM20.755 16.513l-.47 1.406a.703.703 0 101.335.445l.469-1.406a.703.703 0 00-1.334-.445zM14.637 16.068a.703.703 0 00-.445.89l.469 1.406a.703.703 0 101.334-.445l-.469-1.406a.703.703 0 00-.89-.445z" />
    </svg>
);

const EshopIcon: any = () => (
    <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.icon}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.44381 11.9299H6.44473L6.44702 11.9297H17.0704C17.3319 11.9297 17.5619 11.7562 17.6337 11.5048L19.9775 3.30162C20.028 3.12477 19.9926 2.93464 19.882 2.78785C19.7712 2.64106 19.598 2.5547 19.4141 2.5547H5.09249L4.67363 0.669771C4.61397 0.401673 4.37624 0.210938 4.10158 0.210938H0.58594C0.2623 0.210938 0 0.473237 0 0.796877C0 1.12052 0.2623 1.38282 0.58594 1.38282H3.63161L5.7471 10.9028C5.12438 11.1735 4.68752 11.7944 4.68752 12.5157C4.68752 13.4849 5.4761 14.2735 6.44534 14.2735H17.0704C17.394 14.2735 17.6563 14.0112 17.6563 13.6876C17.6563 13.3639 17.394 13.1016 17.0704 13.1016H6.44534C6.12231 13.1016 5.8594 12.8387 5.8594 12.5157C5.8594 12.1931 6.12139 11.9307 6.44381 11.9299ZM18.6373 3.72658L16.6283 10.7579H6.91531L5.35281 3.72658H18.6373ZM5.85939 16.0314C5.85939 17.0006 6.64797 17.7892 7.61721 17.7892C8.58646 17.7892 9.37503 17.0006 9.37503 16.0314C9.37503 15.0621 8.58646 14.2735 7.61721 14.2735C6.64797 14.2735 5.85939 15.0621 5.85939 16.0314ZM7.61721 15.4454C7.94024 15.4454 8.20315 15.7083 8.20315 16.0314C8.20315 16.3544 7.94024 16.6173 7.61721 16.6173C7.29418 16.6173 7.03127 16.3544 7.03127 16.0314C7.03127 15.7083 7.29418 15.4454 7.61721 15.4454ZM15.8985 17.7892C14.9293 17.7892 14.1407 17.0006 14.1407 16.0314C14.1407 15.0621 14.9293 14.2735 15.8985 14.2735C16.8677 14.2735 17.6563 15.0621 17.6563 16.0314C17.6563 17.0006 16.8677 17.7892 15.8985 17.7892ZM16.4844 16.0314C16.4844 15.7083 16.2215 15.4454 15.8985 15.4454C15.5755 15.4454 15.3126 15.7083 15.3126 16.0314C15.3126 16.3544 15.5755 16.6173 15.8985 16.6173C16.2215 16.6173 16.4844 16.3544 16.4844 16.0314Z"
            fill="#27AE60"
        />
    </svg>
);

const ComIcon: any = () => (
    <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.icon}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.5 12c0 5.799-4.701 10.5-10.5 10.5V24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12h1.5C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12z"
        />
        <path d="M12.969 15.852h-2.617V18H8.859v-2.148H7.242v-1.235H8.86v-1.07H7.242V12.32H8.86V6.625h4.196c1.218 0 2.185.31 2.898.93.714.62 1.07 1.458 1.07 2.515 0 1.11-.343 1.966-1.03 2.57-.683.6-1.655.902-2.915.907h-2.726v1.07h2.617v1.235zm-2.617-3.532h2.703c.807 0 1.422-.19 1.843-.57.422-.38.633-.935.633-1.664 0-.662-.219-1.195-.656-1.602-.438-.411-1.029-.62-1.773-.625h-2.75v4.461z" />
    </svg>
);

const icons: any = {
    fz223: FzIcon,
    eshop: EshopIcon,
    com: ComIcon,
};

interface Props {
    reglament: {
        title: string;
        name: string;
    };
}

const ReglamentBadge: React.FC<Props> = ({ reglament }) => {
    const { embedded } = useLayoutContext();
    const reglamentName = camelCase(reglament?.name);
    const Icon = icons[reglamentName] || null;

    return (
        <div suppressHydrationWarning>
            {process.browser && (
                <Popup
                    trigger={
                        <div>
                            <Badge
                                className={clsx(
                                    styles.badge,
                                    styles[
                                        reglamentName as
                                            | 'fz223'
                                            | 'eshop'
                                            | 'com'
                                    ]
                                )}
                            >
                                {Icon && <Icon />}
                                <span> {reglament?.title || '—'}</span>
                            </Badge>
                        </div>
                    }
                    on="hover"
                    position="bottom left"
                    mouseEnterDelay={300}
                >
                    <Link href="/sections">
                        <a
                            className={styles.link}
                            target={embedded ? '_blank' : undefined}
                        >
                            Подробнее о секциях ЭТП
                        </a>
                    </Link>
                </Popup>
            )}
        </div>
    );
};

export default ReglamentBadge;
